<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content">

      <ion-header>
        <ion-toolbar color="success">
          <img height="32" src="/assets/logo-white.png" alt="logotipo"/>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" routerLink="/dashboard" lines="none" detail="false"
                    routerLinkActive="selected">
            <ion-icon aria-hidden="true" slot="start" name="home"></ion-icon>
            <ion-label>Jornada</ion-label>
          </ion-item>

          <ion-item routerDirection="root" routerLink="/sincronizacao" lines="none" detail="false"
                    routerLinkActive="selected">
            <ion-icon aria-hidden="true" slot="start" name="sync-outline"></ion-icon>
            <ion-label>Sincronização</ion-label>
          </ion-item>
          <ion-item-divider></ion-item-divider>
          <span style="font-size: small">Registros</span>
          <ion-item *ngFor="let p of registros; let i = index" routerDirection="root" [routerLink]="[p.url]"
                    lines="none" detail="false"
                    routerLinkActive="selected">
            <ion-icon aria-hidden="true" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
            <ion-label>{{ p.title }}</ion-label>
          </ion-item>
          <ion-item-divider></ion-item-divider>
          <span style="font-size: small">Cadastros</span>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages">
            <ion-item [routerDirection]="'root'" [routerLink]="[p.url]" lines="none">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>
                {{ p.title }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>


          <ion-item-divider></ion-item-divider>
          <span style="font-size: small">{{ agencia }}</span>

          <ion-item *ngIf="token" lines="none" (click)="logout()" detail="false">
            <div class="unread-indicator-wrapper" slot="start">
              <img height="32" [src]="token?.picture" alt="imagem"/>
            </div>
            <ion-label>
              <ion-text>{{ token?.nickname }}</ion-text>
              <br/>
            </ion-label>
            <ion-icon (click)="logout()" slot="end" name="log-out"/>
          </ion-item>
        </ion-menu-toggle>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
